var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"align-center",attrs:{"no-gutters":""}},_vm._l((_vm.checkIns),function(checkIn){return _c('v-col',{key:checkIn.title,class:[
      'd-flex',
      'flex-column',
      'align-center',
      _vm.isTypeEvent ? checkIn.customClass : '',
    ],attrs:{"cols":_vm.isTypeEvent ? 12 : 6}},[_c('v-progress-circular',{staticClass:"mb-2",attrs:{"value":checkIn.percentage,"size":_vm.isTypeEvent ? 100 : 80,"indeterminate":_vm.dashEventLoading,"color":"primary","width":"8"}},[_c('strong',[_vm._v(_vm._s(checkIn.percentage)+"%")])]),_c('strong',{staticClass:"primary--text"},[_vm._v(_vm._s(checkIn.value || 0))]),_c('p',[_vm._v(_vm._s(checkIn.title))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }